import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  AffiliatePayoutBatch,
  AffiliatePayoutBatchAccelerationCommand,
  AffiliatePayoutBatchCommand,
  AffiliatePayoutBatchDetail,
  AffiliatePayoutBatchPage,
} from '../models';

@Injectable({ providedIn: 'root' })
export class AffiliatePayoutClientService {
  private readonly http = inject(HttpClient);
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);

  get(page = 1, pageSize = 50, statusKey?: string): Observable<AffiliatePayoutBatchPage> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (statusKey) params = params.set('statusKey', statusKey);
    return this.http.get<AffiliatePayoutBatchPage>(OperationsApiRoutes.affiliatePayoutBatches, { params, context: this.quietContext });
  }

  getDetail(id: string): Observable<AffiliatePayoutBatchDetail> {
    return this.http.get<AffiliatePayoutBatchDetail>(OperationsApiRoutes.affiliatePayoutBatchById(id), { context: this.quietContext });
  }

  hold(id: string, request: AffiliatePayoutBatchCommand): Observable<AffiliatePayoutBatch> {
    return this.http.post<AffiliatePayoutBatch>(OperationsApiRoutes.affiliatePayoutBatchHold(id), request);
  }

  release(id: string, request: AffiliatePayoutBatchCommand): Observable<AffiliatePayoutBatch> {
    return this.http.post<AffiliatePayoutBatch>(OperationsApiRoutes.affiliatePayoutBatchRelease(id), request);
  }

  accelerate(id: string, request: AffiliatePayoutBatchAccelerationCommand): Observable<AffiliatePayoutBatch> {
    return this.http.post<AffiliatePayoutBatch>(OperationsApiRoutes.affiliatePayoutBatchAccelerate(id), request);
  }
}
